var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptationOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.997,
    height: 20.998,
    viewBox: "0 0 20.997 20.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_795",
    "data-name": "Groupe 795",
    transform: "translate(-177.47 -108.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_394",
    "data-name": "Groupe 394",
    transform: "translate(-1177.053 -543.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M4728.024,22508.521a10.5,10.5,0,1,1,7.421-3.076A10.434,10.434,0,0,1,4728.024,22508.521Zm-4.677-10.574-.9.908,3.542,3.543,7.733-7.734-.909-.9-6.824,6.818Z",
    transform: "translate(-3363 -21835)",
    fill: "#20cc8d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptationOk);
export default __webpack_public_path__ + "static/media/acceptation_ok.bd476ee7.svg";
export { ForwardRef as ReactComponent };